import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import FormGroup from 'components/FormGroup/FormGroup';
import FormItem from 'components/FormItem/FormItem';

import styles from '../../terminal.scss';

function WaitingRegistrationStep(props) {
    const { terminalSettings } = props;

    function getInvitationLink() {
        return terminalSettings.invitation_link || 'https://yookassa.ru';
    }

    function openYookassa() {
        window.open(terminalSettings.oauth_redirect_link || 'https://yookassa.ru', '_blank').focus();
    }

    function getTitle() {
        switch (terminalSettings.registration_status) {
            case 'MANUAL_BOARDING':
                return 'Шаг 2 из 2. Создайте новый магазин';
            case 'SUCCEEDED':
                return 'Шаг 2 из 2. Предоставьте доступ к магазину';
            default:
                return 'Шаг 2 из 2. Регистрация в ЮКасса';
        }
    }

    function getText() {
        switch (terminalSettings.registration_status) {
            case 'MANUAL_BOARDING':
                return (
                    <>
                        Мы нашли ваш аккаунт ЮКасса.
                        <br />
                        <br />
                        Перейдите в личный кабинет, откройте чат с поддержкой и напишите: &quot;Хочу завести новый
                        магазин для Dispurse.app&quot;
                    </>
                );
            case 'SUCCEEDED':
                return (
                    <>Мы нашли ваш аккаунт ЮКасса. Теперь необходимо предоставить доступ к вашему новому магазину.</>
                );
            default:
                return (
                    <>
                        <a href={getInvitationLink()} target="_blank" rel="noreferrer">
                            Перейдите по этой ссылке,
                        </a>{' '}
                        чтобы создать аккаунт ЮКасса, связанный с Dispurse. После завершения регистрации, вернитесь на
                        эту страницу и нажмите &quot;Привязать аккаунт&quot;.
                    </>
                );
        }
    }

    return (
        <FormGroup>
            <FormItem>
                <div className={styles.yookassaLogo}></div>
            </FormItem>
            <FormItem>
                <>
                    <h2 className={styles.yookassaStepTitle}>{getTitle()}</h2>
                    <p className={styles.note}>{getText()}</p>
                </>
            </FormItem>
            <FormItem>
                <Button text="Привязать аккаунт" level="secondary" onClick={openYookassa} />
            </FormItem>
        </FormGroup>
    );
}

WaitingRegistrationStep.propTypes = {
    terminalSettings: PropTypes.shape({
        invitation_link: PropTypes.string,
        registration_status: PropTypes.oneOf(['PENDING', 'MANUAL_BOARDING', 'SUCCEEDED']),
        oauth_redirect_link: PropTypes.string,
    }),
};

export default WaitingRegistrationStep;
